module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('voice-intelligence-dashboard', {
    attrs: {
      "loadingTimeslots": this.$apollo.queries.timeslots.loading,
      "loadingTranscripts": this.$apollo.queries.transcripts.loading,
      "loadingAnalytics": this.$apollo.queries.transcriptAnalytics.loading,
      "transcripts": _vm.transcripts,
      "timeslots": _vm.timeslots,
      "transcriptAnalytics": _vm.transcriptAnalytics
    },
    on: {
      "approve-query": _vm.handleApproveQuery,
      "bulk-approve-query": _vm.handleBulkApproveQuery,
      "export-selected-query": _vm.handleExportSelectedQuery,
      "flag-query": _vm.handleFlagQuery,
      "timeslot-query": _vm.handleSelectedTimeslotQuery,
      "refresh-transcripts": _vm.handleRefreshTranscripts,
      "period-shift": _vm.handlePeriodShift
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16cbb9df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/analytics/VoiceIntelligenceContainer.vue
// module id = 3155
// module chunks = 3